import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import InputField from "../../components/shared/InputField";
import SelectField from "../../components/shared/SelectField";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../../components/shared/NormalButton";
import MultiSelect from "../../components/shared/MultiSelect";
import FilterSelectedValues from "../../components/helpers/filterSelectedValues";
import getUniqueListByKey from "../../components/helpers/GetUniqueListByKey";
import apiClientFiles from "../../components/utils/apiClientFiles";
import apiClientForm from "../../components/utils/apiClientForm";
import Toast from "../../components/shared/Toast";
import UserUploadType from "../../components/shared/UserUploadType";
import useUser from "../../components/helpers/useUser";

const BeneficiariesAddPage = () => {

    const [user, setUser] = useUser();

    const {t,i18n} = useTranslation();
    useDocumentTitle('أضف مستفيد جديد');
    const navigate = useNavigate();
    const pageTitle = {title: 'أضف مستفيد جديد', subTitle: 'يمكنك إضافة مستفيدين النظام الجدد'};
    const [addUserForm,setAddUserForm] = useState({name: '', mobile: '', email:'', role: '', propertyIds:[], companyName: 'defult', unitIds:[] });
    const [errors, setErrors] = useState(null);
    const [roleInfoModal, setRoleInfoModal] = useState(false);
    const [uploadBulkModal, setUploadBulkModal] = useState(false);
    const [isAddUserFormDisabled, setIsAddUserFormDisabled] = useState(true);
    const [properties, setProperties] = useState(null);
    const [propertiesObjects, setPropertiesObjects] = useState(null);
    const [propertiesIds, setPropertiesIds] = useState([]);
    const [units, setUnits] = useState(null);
    const [getUnitsTrigger, setGetUnitsTrigger] = useState(0);
    const [selectedUnitsOptions, setSelectedUnitsOptions] = useState([])
    const [toast, setToast] = useState({show: false,type: null, message:'' });

    const getProperties = async () => {
        try {
          const response = await apiClient.get(`/b-properties?business=${user?.business?._id ? user?.business._id : user?.business}`);
          if(response?.data) {
            setPropertiesObjects(response?.data?.properties);
            setProperties(response?.data?.properties?.map((property) => ({value: property?._id, label: property?.name}) ));
            setPropertiesIds(response?.data?.properties?.map(property =>property?._id));
          } else {
  
          }
        } catch(err) {}
      }

      const getUnits = (propertiesIds) => {
        const getUnits = [];
        propertiesObjects?.map((property) => {
            property?.units?.map((unit) => getUnits.push(unit));
        });
        setUnits(getUnits)
      }

      useEffect(()=>{
        if(Array.isArray(units) && units?.length > 0) {
            const newUnits = getUniqueListByKey(units,'_id');
            if(Array.isArray(newUnits) && newUnits?.length > 0) {
                setUnits(newUnits);
            }
        }
      },[getUnitsTrigger])
  
      useEffect(()=>{
        if(user) {
            getProperties();
        }
      },[user]);

      useEffect(()=>{
        if(Array.isArray(propertiesIds) && propertiesIds?.length) {
            getUnits(propertiesIds);
        }
      },[propertiesIds]);

  
    useEffect(()=>{
      if(addUserForm && addUserForm?.name && addUserForm.mobile)  {
        setIsAddUserFormDisabled(false);
      } else {
        setIsAddUserFormDisabled(true);
      }
    },[addUserForm]);
  
    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }

    const handleClickInfoIcon = () => {
        setRoleInfoModal(true);
    }
    const handleCloseModal = () => {
        setRoleInfoModal(false);
    }

    const handleCloseBulkModal = () => {
        setShowSuccessMessage(false);
        setShowErrorMessage(false);
    }

    const handleSubmitAddUser = () => {
        setErrors(null);
        let errorsList = {};
        if(addUserForm?.name?.length < 2) {
            errorsList.name = 'validation.nameLength';
            }
            if(!/^(5)([0-9]{8})$/.test(addUserForm?.mobile?.replace('+966',''))) {
            errorsList.mobile = 'validation.invalidmobile';
            }
            if(Object.keys(errorsList).length > 0) {
            setErrors(errorsList);
        } else {
            handleClickSubmitAddUserAction();
        }
    }

    const handleClickSubmitAddUserAction = async () => {
        setIsAddUserFormDisabled(true);
        const finalAddUserForm = {...addUserForm, role: 'BENEFICIARY', unitIds: [addUserForm?.unitIds]};
        try {
        const response = await apiClient.post(`/b-users`,Object.fromEntries(Object.entries(finalAddUserForm).filter(([_, v]) => v !== '')));
        if(response?.data) {
            navigate(`/ar/beneficiaries`);
        } else {
            setIsAddUserFormDisabled(false);
        }
        } catch(err) {
            setIsAddUserFormDisabled(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
        }
    }

    const handleChangePropertySelect = (options) => {
        const IdsList = FilterSelectedValues(options);
        const newUnitsOptions = [];
        const newUnitsIds = [];
        IdsList?.map((id) => {
            units?.map((unit) => {if (unit?.propertyId === id) { newUnitsOptions.push({value: unit?._id, label: unit?.name}); newUnitsIds.push(unit?._id) }});
        });
        setSelectedUnitsOptions(newUnitsOptions);
        const newSelectedUnitsValues = addUserForm?.unitIds && Array.isArray(addUserForm?.unitIds) && addUserForm?.unitIds?.length > 0 && addUserForm?.unitIds?.filter(unitId => newUnitsIds.includes(unitId));
        setAddUserForm({ ...addUserForm, unitIds: newSelectedUnitsValues, propertyIds: IdsList });
        hideError('propertyIds');
    }

    const DownloadTemplate = async () => {
        try {
          const response = await apiClientFiles.get('/b-owners/beneficiary-template',{
              responseType: 'blob',
            });
          if(response.data) {
              let fileURL = URL.createObjectURL(response.data);
              let fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.download = 'template';
              fileLink.click();
          } else {
          }
        } catch(err) {}
    }

    // const handleSubmitAddBulkUser = async () => {
    //     setUploadBulkModal(true);
    // }

    const fileRef = useRef();

    const ResetInputFile = () => {
        if(fileRef.current) {
            fileRef.current.value = '';
        }

    }

    const [uploadedFile, setUploadedFile] = useState(null);
    const handleChangeUpload = (e) => {
        setUploadedFile(e.target.files[0]);
        ResetInputFile();
    }


    useEffect(()=>{
        if(!uploadedFile) {
            ResetInputFile();
        }
    },[uploadedFile])

    const [userUploadType,setUserUploadType] = useState('single');

    useEffect(()=>{
        if(userUploadType === 'single') {
            setAddUserForm({name: '', mobile: '', email:'', role: '', propertyIds:[], companyName: 'defult', unitIds:[] });
        } else {
            setUploadedFile(null);
        }
    },[userUploadType])

    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);


    const handleSubmitAddBulk = async () => {
        const body = new FormData();
      body.append('file', (uploadedFile));
      try {
        const response = await apiClientForm.post(`/b-owners/import-beneficiaries`,body,{
            responseType: 'blob',
        })
        if(response?.status === 201) {
            setUploadedFile(null);
            // setShowSuccessMessage(response?.data?.count);
            if(response?.data) {
                if(response?.data?.size < 200) {
                    setShowSuccessMessage(true);
                } else {
                    let fileURL = URL.createObjectURL(response.data);
                    setShowErrorMessage(fileURL);
                }                
            }
        }
      } catch(err) {
            setUploadedFile(null);
            setToast({show:true,type:'error',message:'حدث خطأ في رفع الملف ,من فضلك حاول مرة أخرى في وقت لاحق'});
      }
    }


    const downloadErrorFile = () => {
            let fileLink = document.createElement('a');
            fileLink.href = showErrorMessage;
            fileLink.download = 'Error-Beneficiaries.xlsx';
            fileLink.click();
    }

  return (
    <>
         <div>
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            <MainContent>

                {/* <div className="text-end">
                    <div className="me-[5px] inline-block bg-white text-blue text-center w-[180px] leading-[35px] font-bold h-[40px] cursor-pointer rounded-[8px] border-[2px] border-blue" onClick={()=>DownloadTemplate()}>تحميل قالب المستفيدين</div>
                    <div className="inline-block bg-blue text-white text-center w-[180px] leading-[35px] font-bold h-[40px] cursor-pointer rounded-[8px] border-[2px] border-blue" onClick={()=>handleSubmitAddBulkUser()}>رفع مجموعة مستفيدين</div>
                </div> */}

                <NormalFormContainer heading="من فضلك قم بملئ البيانات التالية لإضافة مستفيد جديد" label="أضف مستفيد">

                    <UserUploadType value={userUploadType} setValue={setUserUploadType} />

                    {userUploadType === 'single' 
                    
                    ? <>
                    <div className="mb-[15px]">
                        <InputField label={t("forms.nameLabel")} placeholder={'اكتب اسم المستفيد هنا'} value={addUserForm?.name} error={errors?.name} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setAddUserForm({ ...addUserForm, name: e.target.value }); hideError('name')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField phone={true} label={t("forms.mobileLabel")} value={addUserForm?.mobile?.replace('+966','')} error={errors?.mobile} errorMessage={errors?.mobile} translateError={true} onChange={(e)=>{ if(e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) { setAddUserForm({ ...addUserForm, mobile: '+966'+e.target.value }) }; hideError('mobile')}} />
                    </div>

                    <div className="mb-[15px]">
                        <InputField type="password" label={'كلمة المرور'} value={addUserForm?.password} error={errors?.password} errorMessage={errors?.password} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setAddUserForm({ ...addUserForm, password: e.target.value }) }; hideError('password')}} />
                    </div>
                    
                    <div className="mb-[15px]">
                        <MultiSelect isMulti label={'اختر المنشأة المعينة للمستفيد '} placeholder={'اسم المنشأة'} options={properties} error={errors?.propertyIds} errorMessage={errors?.propertyIds} value={addUserForm?.propertyIds} onChange={(options)=>{handleChangePropertySelect(options)}} />
                    </div>

                    { Array.isArray(addUserForm?.propertyIds) && addUserForm?.propertyIds?.length > 0 && <div className="mb-[15px]">
                        <MultiSelect label={'اختر الوحدة المعينة للمستفيد '} placeholder={'اسم الوحدة'} options={selectedUnitsOptions} error={errors?.unitIds} errorMessage={errors?.unitIds} value={addUserForm?.unitIds} onChange={(option)=>{setAddUserForm({ ...addUserForm, unitIds: option.value});hideError('unitIds');}} />
                    </div>}

                    <div className="text-end">
                        <NormalButton label={'إضافة المستفيد'} onClick={handleSubmitAddUser} isDisabled={isAddUserFormDisabled} />
                    </div>
                    </>
                    :<>

                    <div className="border-b-[1px] border-b-grey-300">
                        <div className="h-9 justify-end items-center gap-3 inline-flex pt-[24px]">
                            <div className="h-[27px] px-2 bg-lightBlue rounded-[30px] shadow flex-col justify-center items-center gap-2.5 inline-flex">
                                <div className="self-stretch text-right text-darkBlue text-[18px] font-[700]">1</div>
                            </div>
                            <div className="text-right text-darkBlue text-[24px] font-[600]">قم بتنزيل الملف</div>
                        </div>
                        <p className="font-[500] text-[13px] text-grey-950 my-[10px]">يرجى تنزيل الملف المخصص لإضافة المستفيدين</p>
                        <div className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                            <div className="w-[75%] text-grey-600 text-[16px] font-[500]"></div>
                            <div className="w-[25%] text-end">
                                <div className={`inline-block text-[16px] font-[500] cursor-pointer select-none text-blue`} onClick={()=>DownloadTemplate()}>
                                    <span dir="lrt inline-block h-[24px] leading-[24px]">تحميل الملف</span>
                                    <span className="inline-block align-top w-[24px] h-[24px] ms-[5px]" style={{background:"url('/assets/images/import.svg')"}}></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="h-9 justify-end items-center gap-3 inline-flex pt-[24px]">
                            <div className="h-[27px] px-2 bg-lightBlue rounded-[30px] shadow flex-col justify-center items-center gap-2.5 inline-flex">
                                <div className="self-stretch text-right text-darkBlue text-[18px] font-[700]">2</div>
                            </div>
                            <div className="text-right text-darkBlue text-[24px] font-[600]">قم برفع الملف</div>
                        </div>
                        <p className="font-[500] text-[13px] text-grey-950 my-[10px]"> يرجى رفع الملف المخصص لإضافة المستفيدين بعد إضافة البيانات المطلوبة</p>
                        <div className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                            <div className="w-[75%] text-grey-600 text-[16px] font-[500]"></div>
                            <div className="w-[25%] text-end">
                                <div className={`inline-block text-[16px] font-[500] cursor-pointer select-none text-blue relative`}>
                                    <input type="file" id="file" name="file" accept=".xlsx" ref={fileRef} onChange={handleChangeUpload} className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" />
                                    <span dir="lrt inline-block h-[24px] leading-[24px]">رفع الملف</span>
                                    <span className="inline-block align-top w-[24px] h-[24px] ms-[5px]" style={{background:"url('/assets/images/export.svg')"}}></span>
                                </div>
                            </div>
                        </div>
                        {uploadedFile && <div className="flex flex-nowrap gap-x-[10px] mb-[15px] mt-[-5px]">
                            <div className="text-[16px] font-[500] text-grey-600">
                                <span className="inline-block align-middle w-[24px] h-[24px] me-[3px]" style={{background:"url('/assets/images/tick-circle.svg')"}}></span>
                                {uploadedFile?.name}
                                <span className="inline-block align-middle w-[24px] h-[24px] ms-[6px] cursor-pointer select-none" style={{background:"url('/assets/images/close-square.svg')"}} onClick={()=>setUploadedFile(null)}></span>
                            </div>
                        </div>}

                        <div className="text-end pt-[10px]">
                            <NormalButton label={'إضافة المستفيدين'} onClick={handleSubmitAddBulk} isDisabled={!uploadedFile} />
                        </div>
                    </div>
                    
                    </>}
                    
                    

                    {properties?.length === 0 || units?.length === 0 && <div className="bg-white/50 absolute w-full h-full top-0 left-0 right-0 bottom-0">
                        <div className="bg-black/50 text-white p-[25px] rounded-[8px] text-center font-[600] text-[21px] max-w-[300px] mx-auto mt-[200px]">من فضلك يجب إضافة منشآت ووحدات أولا لتتمكن من إضافة مستفيد جديد.</div>
                    </div>}

                </NormalFormContainer>
            </MainContent>
        </PageMain>
        </div>
        { roleInfoModal && <ModalContainer heading="ادوار المستفيدين" handleCloseModal={handleCloseModal}>
            <p className="bg-grey-100 rounded-[8px] p-[12px] mb-[20px]">
                <span className="inline-block bg-darkBlue text-white rounded-[23px] px-[8px] h-[32px] leading-[32px] mb-[10px] font-[600] text-[16px]">مالك حساب</span>
                <span className="block text-[12px] text-grey-900 font-[400] leading-[18px]">نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور </span>
            </p>
            <p className="bg-grey-100 rounded-[8px] p-[12px] mb-[20px]">
                <span className="inline-block bg-blue text-white rounded-[23px] px-[8px] h-[32px] leading-[32px] mb-[10px] font-[600] text-[16px]">المدير</span>
                <span className="block text-[12px] text-grey-900 font-[400] leading-[18px]">نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور </span>
            </p>
            <p className="bg-grey-100 rounded-[8px] p-[12px] mb-[20px]">
                <span className="inline-block bg-orange text-white rounded-[23px] px-[8px] h-[32px] leading-[32px] mb-[10px] font-[600] text-[16px]">الموظف</span>
                <span className="block text-[12px] text-grey-900 font-[400] leading-[18px]">نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور نصاً ما باللغة العربية يمكن استبداله في وقت لاحق ينص علي صلاحيات الدور المذكور </span>
            </p>
            <div className="text-end">
                <NormalButton label={'اغلاق'} onClick={handleCloseModal} />
            </div>
        </ModalContainer> }


        { showSuccessMessage !== false && <ModalContainer heading="إضافة مستفيدين" handleCloseModal={handleCloseBulkModal}>
            <div className="bg-white mx-auto text-center text-grey-900">
                <div className="w-[128px] h-[128px] mx-auto !bg-center !bg-no-repeat" style={{background:"url('/assets/images/success.svg')"}}></div>
                <p className="font-[700] text-[30px] mb-[15px] mt-[25px]">تهانينا !</p>
                <p className="font-[500] text-[24px]">لقد تم إضافة المستفيدين الجدد بنجاح</p>
                
                <div className="flex flex-nowrap px-[16px] py-[8px] my-[15px] mt-[25px]">
                    {/* <div className="w-[50%] text-grey-600 text-[14px] text-start font-[500]">
                        عدد المستفيدين
                    </div>
                    <div className="w-[50%] text-grey-600 text-[14px] text-end font-[500]">
                        {showSuccessMessage} من {showSuccessMessage}
                    </div> */}
                </div>

                <div className="h-[1px] border-t-[1px] border-t-grey-200"></div>
 
                <div className="flex flex-nowrap">
                    <div className="w-[50%] text-center">
                        <div className="bg-blue text-white text-center rounded-[8px] h-[48px] mt-[24px] min-w-[256px] inline-block leading-[48px] font-[600] text-[18px] cursor-pointer" onClick={()=>setShowSuccessMessage(false)}>إضافة مستفيد جديد</div>
                    </div>
                    <div className="w-[50%] text-center">
                        <Link to="/ar/beneficiaries" className="bg-grey-800 text-white text-center rounded-[8px] h-[48px] mt-[24px] min-w-[256px] inline-block leading-[48px] font-[600] text-[18px]">عرض المستفيدين</Link>
                    </div>
                </div>
            </div>
        </ModalContainer> }

        { showErrorMessage !== false && <ModalContainer heading="إضافة مستفيدين" handleCloseModal={handleCloseBulkModal}>
            <div className="bg-white mx-auto text-center text-grey-900">
                <div className="w-[128px] h-[128px] mx-auto !bg-center !bg-no-repeat" style={{background:"url('/assets/images/error.svg')", backgroundSize: '128px'}}></div>
                <p className="font-[700] text-[30px] mb-[15px] mt-[25px]">حدث خطأ!</p>
                <p className="font-[500] text-[24px]">تعذر إضافة المستفيدين الجدد</p>
                
                <div className="flex flex-nowrap border-[1px] bg-grey-50 border-danger px-[16px] py-[8px] my-[15px] mt-[25px]">
                    <div className="w-[50%] text-grey-600 text-[14px] text-start font-[500]">
                        ملف المستفدين الغير مطابقين
                    </div>
                    <div className="w-[50%] text-blue text-[14px] text-end font-[500] cursor-pointer" onClick={()=>downloadErrorFile()}>
                        <span className="w-[24px] h-[24px] inline-block align-middle me-[3px]" style={{ background: "url('/assets/images/import.svg')"}}></span>
                        تحميل الملف
                    </div>
                </div>

                {/* <div className="h-[1px] border-t-[1px] border-t-grey-200"></div> */}
 
                {/* <div className="flex flex-nowrap">
                    <div className="w-[50%] text-center">
                        <div className="bg-blue text-white text-center rounded-[8px] h-[48px] mt-[24px] min-w-[256px] inline-block leading-[48px] font-[600] text-[18px] cursor-pointer" onClick={()=>setShowSuccessMessage(false)}>إضافة مستفيد جديد</div>
                    </div>
                    <div className="w-[50%] text-center">
                        <Link to="/ar/beneficiaries" className="bg-grey-800 text-white text-center rounded-[8px] h-[48px] mt-[24px] min-w-[256px] inline-block leading-[48px] font-[600] text-[18px]">عرض المستفيدين</Link>
                    </div>
                </div> */}
            </div>
        </ModalContainer> }

        <Toast toast={toast} setToast={setToast} />
    </>
  );
};

export default BeneficiariesAddPage;
